import * as React from 'react';
import { Link, LazyImage } from '@grandvisionhq/common';

const FooterAppLinks = ({ items  })=>{
    if (!items.length) {
        return null;
    }
    var _alt;
    return /*#__PURE__*/ React.createElement("div", {
        className: "footer__apps"
    }, items.map((item, index)=>item.image && /*#__PURE__*/ React.createElement("div", {
            key: index,
            className: "footer__apps-item"
        }, /*#__PURE__*/ React.createElement(Link, {
            className: "footer__apps-link",
            url: item.link.url,
            target: item.link.openInNewWindow ? 'external' : undefined,
            labelAccessibility: (_alt = item.link.alt) !== null && _alt !== void 0 ? _alt : ''
        }, /*#__PURE__*/ React.createElement(LazyImage, {
            className: "footer__apps-image",
            src: item.image.url,
            alt: "",
            height: 40,
            width: 120
        })))
    ));
};

export { FooterAppLinks };
//# sourceMappingURL=FooterAppLinks.js.map
